async function setDataDi(phonenumer,prodcutdetails){
  let customer_phonenumer = phonenumer;
  let customer_product_details = prodcutdetails;
  console.log(customer_product_details);
var settings = {
  "url": "https://naariti.myshopify.com/apps/whatsapp/api",
  "method": "POST",
  "timeout": 0,
  "data": {
    "phonenumber": customer_phonenumer,
    "product_details": customer_product_details
  },
};

$.ajax(settings).done(function (response) {
  console.log(response);
});
}